import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


import Header from './components/Header';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Bestellen from './pages/Bestellen';
import UeberUns from './pages/UeberUns';
import Speisekarte from './pages/Speisekarte';
import ReservationForm from './pages/ReservationForm';
import { CartProvider } from './context/CartContext';
import ExperienceSection from './pages/ExperienceSection';
import ImageSliderSection from './pages/ImageSliderSection';
import Testimonials from './pages/Testimonials';
import './styles/index.css';
import Footer from './components/Footer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CheckoutPage from './pages/CheckoutPage';
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './components/AdminLogin';
//import LanguageSwitcher from './components/LanguageSwitcher';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import ScrollToTop from './components/ScrollToTop';
import AGB from './pages/AGB';



import './i18n';

// ProtectedRoute component
const ProtectedRoute = ({ isAuthenticated, children }) => {
  if (!isAuthenticated) {
    return <Navigate to="/admin-login" replace />;
  }
  return children;
};

function Home({ setHeaderVisible }) {
  return (
    <>
      <Hero setIsHeaderVisible={setHeaderVisible} />
      <div id="speisekarte">
        <Speisekarte />
      </div>
      <div id="ueberuns">
        <UeberUns />
      </div>
      <div id="Bestellen">
        <Bestellen />
      </div>
      <div id="ReservationForm">
        <ReservationForm />
      </div>
      <ExperienceSection />
      <ImageSliderSection />
      <Testimonials />
    </>
  );
}

function AppWrapper() {
  const location = useLocation();
  const [headerVisible, setHeaderVisible] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const noHeaderRoutes = ['/checkout', '/impressum', '/datenschutz', '/agb'];
  const isNoHeaderRoute = noHeaderRoutes.includes(location.pathname);
  const { i18n } = useTranslation();

  // set direction attribute (rtl/ltr) based on selected language
  useEffect(() => {
    document.body.setAttribute('dir', i18n.language === 'ar' ? 'rtl' : 'ltr');
  }, [i18n.language]);

  // Check token on mount
  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsAuthenticated(!!token);
  }, []);

  // Hide Header/Navbar on admin routes
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <CartProvider>
      <ToastContainer position="top-right" autoClose={3000} />


      {!isAdminRoute && !isNoHeaderRoute && (
        <>
          <Header onToggle={setHeaderVisible} />
          <Navbar isHeaderVisible={headerVisible} />
        </>
      )}

      {!isAdminRoute && isNoHeaderRoute && (
        <>
          <Navbar isHeaderVisible={false} />
        </>
      )}

      <Routes>
        <Route path="/" element={<Home setHeaderVisible={setHeaderVisible} />} />
        <Route path="/bestellen" element={<Bestellen />} />
        <Route path="/ueber-uns" element={<UeberUns />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/agb" element={<AGB />} />


        <Route
          path="/admin-login"
          element={<AdminLogin onLogin={() => setIsAuthenticated(true)} />}
        />

        <Route
          path="/admin-dashboard"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <AdminDashboard onLogout={() => setIsAuthenticated(false)} />
            </ProtectedRoute>
          }
        />
      </Routes>

      {!isAdminRoute && <Footer />}
    </CartProvider>
  );
}


function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppWrapper />
    </Router>
  );
}

export default App;
